// Step keys for the shooting-club getting-started card. Order = display order.
// Keys MUST match the `steps` object returned by GET /api/customers/club-getting-started
// and the values stored in customer.gettingStartedOverrides (shared with the
// Dyrejournal card — a customer is either a clinic or a club, never both, and
// the key sets do not overlap).
import { computeStepStates, countDone } from './gettingStartedSteps';

const CLUB_STEP_KEYS = [
    'frontpageArticle',
    'feedPost',
    'training',
    'competition',
    'results',
    'policeForm',
    'policeFormSigned',
    'calendar',
    'calendarEvent',
    'weapons',
    'ranges',
    'rangeOfficers',
    'keys',
    'ammoSale',
    'course',
    'shotTrainer',
    'ballisticCalc',
];

function computeClubStepStates(apiSteps, overrides) {
    return computeStepStates(apiSteps, overrides, CLUB_STEP_KEYS);
}

export { CLUB_STEP_KEYS, computeClubStepStates, countDone };
